import { IEventrHotel, IOptionsWithTypes } from '@eventr/common'

export const getAllGuests = (hotel: IEventrHotel) => {
    const all: IOptionsWithTypes[] = []
    hotel?.rooms?.forEach((p) => {
        all.push(...(p.guests ?? []))
    })
    return all
}
